/**
 * WidgetNativeTabs — the ViewIR studio's top-level tab bar. Same shape as
 * `widget/WidgetStudioTabs` (deliberately: the two studios should feel like
 * one product) but with its own tab set and base path.
 */
import { useNavigate } from 'react-router-dom';
import { recallStandardSearch } from './studioNav';

const TABS = [
  { id: 'standard', label: 'Native Widgets' },
  { id: 'bootstrap', label: 'Component Bootstrap' },
];

export default function WidgetNativeTabs({ active, colors }) {
  const navigate = useNavigate();
  const c = colors || { accent: '#6E59F2', text: '#1c1c1e', bgCard: '#fff', border: '#e2e2ea' };
  return (
    <div style={{ display: 'inline-flex', borderRadius: 8, background: c.bgCard, border: `1px solid ${c.border}`, padding: 3 }}>
      {TABS.map((t) => {
        const on = t.id === active;
        return (
          <button
            key={t.id}
            // Returning to Native Widgets restores its last URL state (open
            // widget / graph / focus / page), so the round-trip doesn't reset it.
            onClick={() => navigate(`/playground/widget-native/studio/${t.id}${t.id === 'standard' ? recallStandardSearch() : ''}`)}
            style={{
              background: on ? c.accent : 'transparent',
              color: on ? '#fff' : c.text,
              border: 'none', borderRadius: 6,
              padding: '8px 14px', fontSize: 13, fontWeight: 600,
              letterSpacing: '-0.01em', cursor: 'pointer', whiteSpace: 'nowrap',
            }}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
}
